module.exports = __webpack_public_path__ + "img/rating-ico-1.5a317ff4.png";